import { render, staticRenderFns } from "./kpsrOnePage.vue?vue&type=template&id=512e2cbb"
import script from "./kpsrOnePage.vue?vue&type=script&lang=js"
export * from "./kpsrOnePage.vue?vue&type=script&lang=js"
import style0 from "./kpsrOnePage.vue?vue&type=style&index=0&id=512e2cbb&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('512e2cbb')) {
      api.createRecord('512e2cbb', component.options)
    } else {
      api.reload('512e2cbb', component.options)
    }
    module.hot.accept("./kpsrOnePage.vue?vue&type=template&id=512e2cbb", function () {
      api.rerender('512e2cbb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/kpsr/kpsrOnePage.vue"
export default component.exports